/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTariffLineItem.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/tariff-line-item";

export class AutogenModelTariffLineItem<RowType extends ModelRow> extends Endpoint<RowType, RowTariffLineItemFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTariffLineItem extends ModelRow<RowTariffLineItemFields> {
	constructor(values?: Partial<RowTariffLineItemFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowTariffLineItemFields {
	add_timestamp: Date;
	add_userid: string;
	affected_customers: string;
	apply_deficit_rating_flag: boolean;
	average_pallet_weight: number;
	bfg_type_code: string;
	calc_factor: string;
	calc_factor_2: number;
	calc_uom_code: string;
	carrier_scac: string;
	charge_regardless_flag: boolean;
	commissionable_flag: boolean;
	company_id: string;
	compare_option_code: string;
	cons_reg_name: string;
	cons_reg_uid: number;
	conveyance_type_code: string;
	cubic_units: number;
	cur_uid: number;
	currency_type: string;
	default_currency_type: string;
	description: string;
	dim_weight_multiplier: number;
	dow_code: string;
	effective_timestamp: Date;
	exchange_pt_loc_id: string;
	expire_timestamp: Date;
	fallback_tar_uid: number;
	fallback_tariff_id: string;
	fifty_fifty_split: boolean;
	freight_value: number;
	from_time: Date;
	gla_uid: number;
	handling_units: number;
	icc_id: string;
	linear_units: number;
	manual_override_flag: boolean;
	maximum_charge: number;
	miles: number;
	minimum_charge: number;
	minimum_weight_per_pallet: number;
	mod_timestamp: Date;
	mod_userid: string;
	nmfc: string;
	payee_id: string;
	pieces: number;
	priority: number;
	product_sku: string;
	qual_factor_1: string;
	qual_factor_2: string;
	rate: number;
	rate_note: string;
	reversible_flag: boolean;
	rxz_type_code: string;
	seats: number;
	service_type_code: string;
	ship_reg_name: string;
	ship_reg_uid: number;
	special_points_reg_uid: number;
	spots: number;
	surchargeable_flag: boolean;
	tar_uid: number;
	tariff_id: string;
	tariff_name: string;
	tariff_type_code: string;
	taxable_flag: boolean;
	thru_time: Date;
	tli_uid: number;
	unit_type_code: string;
	weight: number;
	customer_ids: string;
	tariff_ids: string;
	type: string;
}

